// extracted by mini-css-extract-plugin
export default {"backBtn":"BackButton_backBtn__mcW-W","backBtnText":"BackButton_backBtnText__ocabA"};